import { createApiClient } from './api';
import { env } from './env';

/** The app's API client. Import this, not fetch. */
export const api = createApiClient(env.apiUrl);
